import React, { useContext } from 'react';
import { Container, Row } from 'reactstrap';
import { useTranslation } from 'react-i18next';
import { useLocation, useNavigate } from 'react-router';
import OperationContext from '../../context';
import { PageHeader, Section, LinkButton } from '../../../../../shared/components';
import EsmrContext from './context';
import NotificationContext from '../../../../Notifications/NotificationContext';
import FlowMain from '../FlowMain';
import FlowStart from '../FlowStart';
import operEsmrService from '../../../../../services/operEsmrService';
import useQuery from '../../../../../shared/hooks/useQuery';
import FlowTitleWarning from '../FlowTitleWarning';

const Esmr: React.FC = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { t } = useTranslation();
  const { operation } = useContext(OperationContext);
  const { data, loader, reload } = useContext(EsmrContext);
  const { reload: reloadNotifications } = useContext(NotificationContext);

  const queryParams = useQuery();
  const from = queryParams.get('from') || undefined;

  const reloadWithNotifications = () => {
    reload();
    reloadNotifications();
  };

  const getContent = () => {
    if (!data) {
      return null;
    }
    return data.content ? (
      <FlowMain
        data={data}
        reload={reloadWithNotifications}
        operFlowService={operEsmrService}
        flowType="ESMR"
      />
    ) : (
      <FlowStart
        hasToolkitEsrr={data.hasToolkitEsrr}
        hasIndicators={data.hasIndicators}
        loader={loader}
        reload={reloadWithNotifications}
        operFlowService={operEsmrService}
        flowType="ESMR"
        milestoneCreateConditionDate={data.milestoneCreateConditionDate}
      />
    );
  };

  const GoToComments = () => {
    navigate(`${location.pathname}/comments`);
  };

  return (
    <Container className="dashboard">
      <PageHeader title={<>{t('titleEsmr', { number: operation.number })}</>} backUrl={from} />
      <Row>
        <Section
          title={data && data.content ? t('titleSectionEsmr') : ''}
          title2={
            data &&
            data.ownerOperation &&
            data.ownerOperation.number !== operation.number && (
              <FlowTitleWarning operationNumber={data.ownerOperation.number} />
            )
          }
          titleButton={
            data && (
              <>
                <LinkButton onClick={GoToComments} icon="comment" text={t('comments')} />
                <span className="comment-counter">({data.commentCount})</span>
              </>
            )
          }
        >
          {getContent()}
        </Section>
      </Row>
    </Container>
  );
};

export default Esmr;
